module.exports = __webpack_public_path__ + "static/media/nodata.f7a55960.png";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/stationTobu/nodata.png
// module id = 5135
// module chunks = 0